import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function pageTemplateFormFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('PAGE.TEMPLATE_NAME'),
        required: true,
      },
    },
    {
      key: 'columns',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('PAGE.COLUMNS'),
        required: true,
        type: 'number',
        min: 1,
      },
    },
    {
      key: 'rows',
      type: 'input',
      className: 'mb-2 block',
      props: {
        label: translate.instant('PAGE.ROWS'),
        required: true,
        type: 'number',
        min: 1,
      },
    },
  ];
}

